import { render, staticRenderFns } from "./BannerIndex.vue?vue&type=template&id=15a835f3&"
import script from "./BannerIndex.vue?vue&type=script&lang=js&"
export * from "./BannerIndex.vue?vue&type=script&lang=js&"
import style0 from "./BannerIndex.vue?vue&type=style&index=0&id=15a835f3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports